import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Card, DatePicker, Form, Input } from 'antd';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
// import regIcon from 'assets/images/register-icon.svg';
// import { RegistrationFlowContext } from 'contexts/registration';
// import { RegistrationFormData } from 'contexts/registration/registrationFormData';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { DEFAULT_DATE_FORMAT, disabledDate, setErrorCodeFun } from 'utils';
// import { IconTitle } from 'components';
import { useAddAnotherEbValidate } from 'all-in-one-shared-api';
import PolicyAndMemberIdModal from '../forget/PolicyAndMemberIdModal';
// import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
// import { revalidateAntdFormLanguageChanged } from '../../../../i18n';
import { StyledTitle } from 'components/StyledTitle';
import { InfoCircleOutlined } from '@ant-design/icons';
import './EbConnect.less';
// import _get from 'lodash/get';
import moment from 'moment';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { NamePath } from 'rc-field-form/es/interface';

export type FormData = {
  policyNumber: string;
  memberId: string;
  date: string;
  dob?: moment.Moment;
  dobAddEb?: moment.Moment;
};
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

function ProfileConnectEb() {
  // const [ApiError, setApiError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  const initialValues = useRegistrationStateQuery();
  const navigate = useNavigate();
  const dateFormat = DEFAULT_DATE_FORMAT;
  const [snackbarMessage, setSnackbarMessage] = useState(initialValues.registerError || '');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const [randoms, setRandoms] = useState(0);
  const [validateEbError, setValidateEbError] = useState('');
  const [form1, setForm1] = useState((): FormData => {
    return {
      policyNumber: '',
      memberId: '',
      date: '',
    };
  });

  const { keycloak } = useKeycloak();
  const {
    shouldFetch: EbPolicyValidateFetch,
    data: EbPolicyValidateData,
    error: EbPolicyValidateError,
    isLoading,
  } = useAddAnotherEbValidate(
    'useAddAnotherEbValidate' + randoms,
    keycloak.token as string,
    form1.policyNumber,
    form1.memberId,
    form1.date,
  );
  const [errorCode, setErrorCode] = useState({
    code: '',
    message: '',
  });
  /* eslint-disable */
  useEffect(() => {
    if (EbPolicyValidateData) {
      EbPolicyValidateFetch(false);
      navigate('/EbProfileConnectOtp', {
        state: {
          email: EbPolicyValidateData.message,
          policyNumber: form1.policyNumber || '',
          memberId: form1.memberId,
          birthDate: form1.date,
        },
      });
    }
    console.log(EbPolicyValidateError, 'EbPolicyValidateError');
    if (EbPolicyValidateError?.code && EbPolicyValidateError?.message) {
      const message = setErrorCodeFun(EbPolicyValidateError.code, i18n.language);
      setErrorCode(
        EbPolicyValidateError as {
          code: string;
          message: string;
        },
      );
      setValidateEbError(message ?? EbPolicyValidateError.message);
    }
    EbPolicyValidateFetch(false);
  }, [EbPolicyValidateData, EbPolicyValidateError, i18n.language]);
  /* eslint-disable */

  useEffect(() => {
    return () => {
      EbPolicyValidateFetch(false);
    };
  }, []);
  const handleCloseSnackbar = () => {
    setSnackbarMessage('');
    setValidateEbError('');
  };
  function onValidateSuccessful(event?: React.BaseSyntheticEvent) {
    event && event.preventDefault();
    setRandoms(Math.random());
    EbPolicyValidateFetch(true);
  }
  useEffect(() => {
    let name: NamePath[] | undefined = [];
    form.getFieldsError().forEach((d) => {
      if (d.errors.length && d.name) {
        name = name?.concat(d.name);
      }
    });
    console.log(form.getFieldsError(), 'form.getFieldsError()');

    if (form.getFieldsError().some((errors) => errors.errors.length)) {
      form.validateFields(name);
    }
    if ((errorCode.code || errorCode.message) && validateEbError) {
      const message = setErrorCodeFun(errorCode.code, i18n.language);

      setValidateEbError(message ?? errorCode.message);
    }
  }, [i18n.language]);
  const onFinish = (values: FormData) => {
    console.log(values, '================');
    setForm1({
      ...form1,
      policyNumber: values.policyNumber,
      memberId: values.memberId,
      date: moment(values.dobAddEb).format('DD/MM/YYYY'),
    });
    onValidateSuccessful();
  };
  const closeModel = () => {
    setIsModalVisible(false);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };
  // const prefixSelector = <MobileNumberPrefix handleChange={handleChange} />;
  const infoIcon = <InfoCircleOutlined style={{ cursor: 'pointer' }} onClick={showModal} />;

  return (
    <div
      className="eb_connect_wrapper"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
      }}
    >
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, border: 0 }}>
          <div
            className="title"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // backgroundColor: 'pink',
            }}
          >
            <StyledTitle level={4}>{t('registration.EB.connectEBTitle')}</StyledTitle>
          </div>
          <div className="connectEBRemind">
            <StyledTitle level={5} type="secondary" margin="0 0 24px 0">
              {t('registration.EB.connectEBRemind')}
            </StyledTitle>
          </div>
          <StyledTitle className="secondary" level={5} type="secondary">
            {t('forgetLoginId.mandatoryMsg')}
          </StyledTitle>
          {!!snackbarMessage && (
            <Alert
              message={t(snackbarMessage)}
              type="error"
              // closable
              onClose={handleCloseSnackbar}
              style={{ marginBottom: 16 }}
            />
          )}
          <Form
            className="eb_connect_form"
            initialValues={initialValues}
            layout={'vertical'}
            requiredMark={false}
            onFinish={onFinish}
            form={form}
            validateTrigger={'onBlur'}
            style={{ width: '100%' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                width: '100%',
                // backgroundColor: 'pink',
              }}
            >
              <Form.Item
                label={t('life.forgetLoginId.policyNumber')}
                name="policyNumber"
                className="policyNumber"
                rules={[
                  { required: true, message: t('registration.error.required') },
                  // {
                  //   validator: (_, value) => {
                  //     if (value && !verifyPolicyNumber(value)) {
                  //       return Promise.reject(new Error(t('registration.error.invalidPolicyNumber')));
                  //     }
                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
                style={{ marginBottom: 12, color: '#752127', width: '100%' }}
                tooltip={{ icon: infoIcon }}
              >
                <Input
                  maxLength={8}
                  size="middle"
                  onChange={(val) => {
                    setForm1({
                      ...form1,
                      policyNumber: val.target.value,
                    });
                  }}
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                  placeholder={t('registration.EB.policyNumberHolder')}
                  // onKeyPress={(event) => {
                  //   if (!/[0-9a-zA-Z]/.test(event.key)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                />
              </Form.Item>
              <Form.Item
                label={t('life.forgetLoginId.memberId')}
                name="memberId"
                className="memberId"
                rules={[
                  { required: true, message: t('registration.error.required') },
                  // {
                  //   validator: (_, value) => {
                  //     if (value && !verifyMemberId(value)) {
                  //       return Promise.reject(new Error(t('registration.error.invalidPolicyNumber')));
                  //     }
                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
                style={{ marginBottom: 12, color: '#752127', width: '100%' }}
                tooltip={{ icon: infoIcon }}
              >
                <Input
                  maxLength={12}
                  onChange={(val) => {
                    setForm1({
                      ...form1,
                      memberId: val.target.value,
                    });
                  }}
                  size="middle"
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                  placeholder={t('life.forgetLoginId.enterMemberId')}
                  // onKeyPress={(event) => {
                  //   if (!/[0-9a-zA-Z]/.test(event.key)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                />
              </Form.Item>
              <Form.Item
                label={t('registration.dobLabel') + '*'}
                name="dobAddEb"
                rules={[{ required: true, message: t('registration.error.required') }]}
                style={{ width: '100%' }}
              >
                <DatePicker
                  disabledDate={disabledDate}
                  placeholder={t('common.placeholder.date')}
                  format={dateFormat}
                  onChange={(e) => {
                    setForm1({
                      ...form1,
                      dobAddEb: e || undefined,
                    });
                  }}
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    color: 'white',
                    backgroundColor: 'transparent',
                    width: '100%',
                  }}
                />
              </Form.Item>
              {validateEbError && (
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Alert
                    message={validateEbError}
                    className="error-register"
                    type="error"
                    // closable
                    onClose={handleCloseSnackbar}
                    style={{ marginBottom: 0 }}
                  />
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  // backgroundColor: 'pink',
                }}
              >
                <Form.Item style={{ width: 428 }} className="form_btn">
                  <Button
                    block
                    className="btn"
                    type="primary"
                    loading={isLoading}
                    size="large"
                    disabled={!form1.dobAddEb || !form1.memberId || !form1.policyNumber}
                    htmlType="submit"
                  >
                    {t('common.submit')}
                  </Button>
                </Form.Item>
                {/* <Link
                  style={{
                    fontWeight: 'normal',
                    marginLeft: 4,
                    marginRight: 4,
                    color: '#C21B17',
                    textDecoration: 'underline',
                  }}
                  to="/forgot/login"
                >
                  {t('life.forgetLoginId.Needhelp')}
                </Link> */}
              </div>
            </div>
          </Form>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </div>
  );
}

export default ProfileConnectEb;
